<!--
 * @Description: 运营总览顶部组件
 * @Author: sunhuihong
 * @Date: 2022-07-13 09:43:52
 * @LastEditTime: 2022-07-13 17:33:29
-->
<template>
  <el-row type="flex" justify="space-between" style="text-align: left;">
    <el-col :span="5" style="padding-left: 0" v-for="(item,index) in headerData" :key="index" >
      <div  @click="handleItem(index)" :class="[index == 0 ? 'add-inst' : index == 1 ? 'add-hosp' : index == 2 ?
        'online-user' : index == 3 ? 'online-attent' : '']"> 
          <div class="header-list-title">
             <span>{{item.title}}</span>
          </div>
          <div class="header-list-number">
            <span>
              {{index == 0 ? overviewTopStatisticsDO.totalInstitutionCount : index == 1 
                ? overviewTopStatisticsDO.totalHospitalCount : index == 2 
                ? overviewTopStatisticsDO.onlineUserCount : index == 3 
                ? overviewTopStatisticsDO.onlineAttendantCount : ''
              }}
            </span>
          </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
    name: 'HeaderList',
    props: ["overviewTopStatisticsDO"],
    data() {
        return {
          headerData : [
            {title: '累计签约机构', unit: '家'},
            {title: '累计签约医院', unit: '家'},
            {title: '在线用户', unit: '人'},
            {title: '在线护工', unit: '人'}
          ],
        }
    },

    methods: {
      handleItem(index) {
        this.$emit("handle-jump-page", index);
      }
    },
}
</script>

<style scoped>
.add-inst {
  height: 93px;
  background: linear-gradient(90deg, #3ABBB8 0%, #39BCB9 100%);
  border-radius: 10px;
  border: 1px solid #E3E6EF;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.add-hosp {
  height: 93px;
  background: linear-gradient(90deg, #F28783 0%, #FA7A72 100%);
  border-radius: 10px;
  border: 1px solid #E3E6EF;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.online-user {
  height: 93px;
  background: linear-gradient(90deg, #95A9EA 0%, #707FEF 100%);  
  border-radius: 10px;
  border: 1px solid #E3E6EF;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.online-attent {
  height: 93px;
  background: linear-gradient(90deg, #F7AD78 0%, #F79A5E 100%);
  border-radius: 10px;
  border: 1px solid #E3E6EF;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header-list-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
}

.header-list-number {
  width: 100%;
  text-align: right;
  font-size: 40px;
  font-weight: 600;
  color: #FFFFFF;
}
</style>





// WEBPACK FOOTER //
// src/components/overview/components/HeaderList.vue